import { useFetch } from './useFetch'
import type { TenantDTO } from '../types'

export function useTenants() {
  const { data: tenants, isLoading, error } =
    useFetch<TenantDTO[]>('/v1/tenants', [])
  return { tenants, isLoading, error }
}
